import { AxiosResponse } from 'axios';

import authNetworkService from '../auth-network/auth-network.service';
import digitalCertificatesUrls from './digital-certificates.urls';

const createProgressHandler =
  (onUploadProgress: (percentage: number) => void) => (progressEvent: ProgressEvent) => {
    if (!progressEvent.lengthComputable || !progressEvent.total) {
      return;
    }
    onUploadProgress(Math.round((progressEvent.loaded * 100) / progressEvent.total));
  };

const bulkGenerate = (
  file: File,
  onUploadProgress?: (percentage: number) => void,
): Promise<AxiosResponse<Blob>> => {
  const url = digitalCertificatesUrls.bulkGenerate();
  const form = new FormData();
  form.append('File', file);
  return authNetworkService.post(url, form, {
    responseType: 'blob',
    timeout: 0,
    onUploadProgress: onUploadProgress && createProgressHandler(onUploadProgress),
  });
};

export default {
  bulkGenerate,
};
